export default __webpack_public_path__ + "static/CommunityBg-0823c352937470ff7ce0fedc8ed56d7c.png";